import { User } from "@/models/users/User";

export const formatDateToDanishLocaleOnlyDateLongMonth = (
  date: Date
): string => {
  return date.toLocaleDateString("da-DK", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const formatDateToDanishForFilename = (date: Date): string => {
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${day}_${month}_${year}__${hours}${minutes}`;
};

export const formatDateToDanishLocaleOnlyDateInNumbers = (
  date: Date
): string => {
  return date.toLocaleDateString("da-DK", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  });
};

export const formatDateToDanishLocaleOnlyDateShortMonth = (
  date: Date
): string => {
  return date.toLocaleDateString("da-DK", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

export const formatDateToDanishLocaleOnlyDateShortMonthWithTime = (
  date: Date
): string => {
  return date.toLocaleDateString("da-DK", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatDateToDanishLocaleLongMonthWithTime = (
  date: Date
): string => {
  return date.toLocaleDateString("da-DK", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatDateToDanishLocaleWithTimeOnlyNumbers = (
  date: Date
): string => {
  return date.toLocaleDateString("da-DK", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatTextString = (text: string): string => {
  // Replacing both actual newlines and literal \n text sequences
  const temp = text
    .replace(/(?:\r\n|\r|\n)/g, "<br>") // Replaces actual newlines
    .replace(/\\n/g, "<br>"); // Replaces literal \n text
  return temp;
};

export const formatUsersName = (user: User | undefined | null): string => {
  if (!user) return "-";
  return user.firstName && user.lastName
    ? user.firstName + " " + user.lastName
    : (user.email ?? "-");
};

export const formatUserAvatarFallback = (
  user: User | undefined | null
): string => {
  if (!user) return "-";
  return user.firstName && user.lastName
    ? user.firstName.charAt(0).toUpperCase() +
        user.lastName.charAt(0).toUpperCase()
    : user.email !== undefined && user.email !== null
      ? user.email.charAt(0).toUpperCase() +
        user.email.split("@")[1]?.charAt(0).toUpperCase()
      : "-";
};
